import http from '@/libs/http.js'

export function updateMonthTask (monthTask) {
  return http.post('/crm/dashboard/setmonthtask', monthTask)
}

export function listMonthTask (month, area) {
  return http.get('/crm/dashboard/listmonthtask', { params: { month, area } })
}

export function loadDayOrderInfo (area, timeStart, timeEnd) {
  return http.get('/crm/dashboard/listdayareastatistic', { params: { area, timeStart, timeEnd } })
}

export function loadLastestOrderInfo (area) {
  return http.get('/crm/dashboard/listlastestorder', { params: { area } })
}

export function loadSystemMssage () {
  return http.get('/crm/dashboard/listsystemmessage')
}

export function loadMonthAreaBrand (startTime, endTime, area) {
  return http.get('/crm/dashboard/ListMonthAreaBrand', { params: { startTime, endTime, area } }).then((resp) => {
    const { showAreas, brandData } = resp
    const brands = [
      {
        name: 'bmw',
        codes: ['bmw', 'mini', 'rolls_royce']
      },
      {
        name: 'benz',
        codes: ['benz', 'smart', 'maybach']
      },
      {
        name: 'landrover',
        codes: ['landrover', 'jaguar']
      },
      {
        name: 'audi',
        codes: ['vw', 'audi', 'porsche']
      }
      // },
      // {
      //   name: 'others',
      //   ncodes: [ 'vw', 'audi', 'porsche', 'landrover', 'jaguar', 'benz', 'smart', 'maybach', 'bmw', 'mini', 'rolls_royce' ]
      // }
    ]
    const result = showAreas.map(t => {
      const ret = {
        area: t
      }
      brands.forEach(b => {
        let seriesData = []
        if (b.name === 'others') {
          seriesData = brandData.filter(bd => bd.area === t && b.ncodes.indexOf(bd.brandCode) === -1)
        } else {
          seriesData = brandData.filter(bd => bd.area === t && b.codes.indexOf(bd.brandCode) > -1)
        }
        ret[b.name + 'PureSell'] = seriesData.reduce((p, c) => p + c.sellAmount - c.returnAmount, 0)
        ret[b.name + 'Sell'] = seriesData.reduce((p, c) => p + c.sellAmount, 0)
        ret[b.name + 'Ret'] = seriesData.reduce((p, c) => p + c.returnAmount, 0)
        ret[b.name + 'Count'] = seriesData.reduce((p, c) => p + c.orderCount, 0)
      })
      return ret
    })
    return result
  })
}

export function listMetrix () {
  return http.get('crm/dashboard/listmetrixs')
}

export function setMonthMetrix (monthMetrixs, month) {
  return http.put('crm/dashboard/setmonthmetrix', monthMetrixs, { params: { month } })
}

export function listMonthMetrix (month, area) {
  return http.get('crm/dashboard/listmonthmetrixs', { params: { month, area } })
}

export function copyLastMonthMetrix (month) {
  return http.get('crm/dashboard/CopyPreMonthMetrix', { params: { month } })
}

export function setSeasonMetrix (monthMetrixs, season) {
  return http.put('crm/dashboard/setseasonmetrix', monthMetrixs, { params: { season } })
}

export function listSeasonMetrix (season, area) {
  return http.get('crm/dashboard/listseasonmetrixs', { params: { season, area } })
}

export function copyLastSeasonMetrix (season) {
  return http.get('crm/dashboard/copypreseasonmetrix', { params: { season } })
}

export function queryDayIncomeData (queryModel) {
  return http.get('crm/statistic/dayincome', { params: queryModel })
}
